import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { PublicIssueComplaintType } from '../../enums/public-issue-complaint-type';
import { PublicIssueFileRequest } from './public-issue-file.request';

@jsonObject
export class PublicIssueComplaintRequest {
  @jsonArrayMember(String)
  public readonly reasons!: PublicIssueComplaintType[];

  @jsonMember(String)
  public readonly orderNumber!: string;

  @jsonArrayMember(PublicIssueFileRequest)
  public readonly files!: PublicIssueFileRequest[];

  public constructor(
    private readonly data: {
      reasons: PublicIssueComplaintType[];
      orderNumber: string;
      files: PublicIssueFileRequest[];
    },
  ) {
    this.reasons = this.data.reasons;
    this.orderNumber = this.data.orderNumber;
    this.files = this.data.files;
  }
}
